<template>
  <v-card width="100%" class="mx-auto">
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" lg="6">
              <v-radio-group v-model="scheduleMode" dense row label="Schedule Mode">
                <v-radio value="single" label="One Time">
                </v-radio>
                <v-radio value="recurring" label="Recurring">
                </v-radio>
              </v-radio-group>
          </v-col>
          <v-col cols="12" lg="6">
            <div v-if="scheduleMode == 'recurring'">
              <div v-show="false">
                  Repeat Every
                  <v-text-field
                    v-model="repeatWeekInterval"
                    hide-details
                    disabled
                    style="width: 50px; display: inline-block"
                  />
                  week(s)
              </div>
              <div>
              Day of Weeks*
              <v-btn-toggle @change="calculateDates" class="ml-0 ml-lg-2" multiple v-model="selectedWeekdays">
                <v-btn v-for="day in weekdays" :key="day">
                  {{ day }}
                </v-btn>
              </v-btn-toggle>
              </div>
            </div>
          </v-col>
          <v-col cols="12" :lg="scheduleMode == 'recurring' ? 6:12">
            <v-text-field
                  v-model="startDate"
                  label="Start Date*"
                  prepend-icon="mdi-calendar"
                  type="date"
                  clearable
                  :rules="[rules.required]"
                  required
                  @change="calculateDates"
                ></v-text-field>
          </v-col>
          <v-col v-if="scheduleMode == 'recurring'" cols="12" lg="6">
            <v-text-field
                  v-model="endDate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  type="date"
                  clearable
                  :rules="[rules.dateRange(startDate, endDate)]"
                  @change="calculateDates"
                ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field
                  v-model="startTime"
                  label="Start Time*"
                  prepend-icon="mdi-clock-time-four-outline"
                  type="time"
                  :rules="[rules.required]"
                  required
                  @change="calculateDates"
                ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-text-field
                  v-model="endTime"
                  label="End Time*"
                  prepend-icon="mdi-clock-time-four-outline"
                  type="time"
                  :rules="[rules.required, rules.timeRange(this.startTime, this.endTime)]"
                  required
                  @change="calculateDates"
                ></v-text-field>
          </v-col>
          <v-col v-if="scheduleMode == 'recurring'" cols="12" lg="12">
            <v-select
              clearable
              prepend-icon="mdi-calendar-remove"
              label="Exclude Date"
              multiple
              v-model="excludeDates"
              :items="availableDates"
              item-text="label"
              item-value="value"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="12">
            <v-textarea v-model="remark" :auto-grow="true" rows="1" label="Remark" />
          </v-col>
        </v-row>
        <v-row v-if="id != null">
          <v-col cols="12" lg="12">
            <v-layout class="ml-1 mr-1" row>
              <v-checkbox v-model="syncGoogleCalendarEvent" label="Sync schedule with Google calendar" />
            </v-layout>
          </v-col>
        </v-row>
      </v-form>
      <slot name="actions">
        <v-card-actions class="mt-5">
          <v-btn @click="back" class="mx-5">{{backBtnLabel ? backBtnLabel:'Back'}}</v-btn>
          <v-spacer />
          <v-btn :loading="isAppLoading" :disabled="isAppLoading" @click="saveSchedule" color="primary" class="mx-5"
            >{{saveBtnLabel ? saveBtnLabel:'Next'}}</v-btn
          >
        </v-card-actions>
        <div class="text-caption my-5">
          <span style="color: red">*</span> Denotes required field
        </div>
      </slot>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
import { DateTime } from 'luxon';
import {rules} from "@/store/util/rules.js";
import rruleUtil from '@/store/util/rruleUtil.js'


export default {
  props: ['value', 'saveBtnLabel', 'backBtnLabel'],
  data() {
    return {
      id: null,
      scheduleMode: 'recurring',
      startTime: null,
      endTime: null,
      startDate: new moment().format("YYYY-MM-DD"),
      repeatWeekInterval: 1,
      endDate: null,
      selectedWeekdays: [],
      weekdays: ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"],
      excludeDates: [],
      syncGoogleCalendarEvent: true,
      selectedReminders: [60, 1440],
      reminders: [{text: '3 Day', value: 4320}, {text: '1 Day', value: 1440}, {text: '5 hours', value: 300}, {text: '1 hour', value: 60}],
      googleAccounts: [],
      gSuiteAccounts: [],
      availableDates: [],
      googleCalendarOwner: null,
      remark: '',
      rules
    };
  },
  watch: {
    // startDate(start) {
    //   this.calculateDates(start, this.endDate);
    // },
    // endDate(end) {
    //   this.calculateDates(this.startDate, end);
    // },
    // selectedWeekdays() {
    //   this.calculateDates(this.startDate, this.endDate);
    // },
    // value(newVal){
    //   console.log('new schedule value')
    //   console.log(newVal);
    //   this.initialize();
    // }
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading", "currentUser"]),
  },
  mounted(){
    console.log('initializing.')

    if(this.$route.params.scheduleMode){
      this.scheduleMode = this.$route.params.scheduleMode;
    }
    
    if(this.$route.params.date){
      this.startDate = this.$route.params.date
    }

    this.loadGoogleAccounts();
    this.initialize();
  },
  methods: {
    ...mapActions(["hideDialog", "addMessage", "addErrorMessage", "addSuccessMessage"]),
    back(){
      this.$emit('clickBack', this.$event);
    },
    initialize(){
      if(this.value.id){
        this.id = this.value.id;
        this.startDate = moment(this.value.startDate).format('YYYY-MM-DD')
        this.endDate = this.value.endDate ? moment(this.value.endDate).format('YYYY-MM-DD'):null;
        this.selectedWeekdays = this.value.daysOfWeek ? this.value.daysOfWeek.map(dow => parseInt(dow)):[];
        this.rrule = this.value.rrule
        if(this.rrule){
          this.scheduleMode = 'recurring'
        }
        else{
          this.scheduleMode = 'single'
        }
        this.remark = this.value.remark
        this.startTime = this.value.startTime
        this.endTime = this.value.endTime
        this.createGoogleCalendarEvent = this.value.googleEventId != null ? true:false
        this.googleCalendarOwner = this.value.googleCalendarAccount
        this.excludeDates = this.value.exclusionDates ? this.value.exclusionDates.map(e => {return moment(e.date).format("YYYY-MM-DD")}):[];
      }
      this.calculateDates();
    },
    loadGoogleAccounts() {
      this.$axios
        .get("/account/gsuite-accounts")
        .then((resp) => {
          this.gSuiteAccounts = resp.data;
          this.googleAccounts = this.gSuiteAccounts.map((acct) => {
            return {
              name: `${acct.email} (${acct.firstName} ${acct.lastName})`,
              value: acct.email,
            };
          });
          if(this.googleAccounts && this.googleAccounts.length > 0 && !this.googleCalendarOwner){
            const currentUserEmail = this.currentUser.email;
            const matchingAccount = this.gSuiteAccounts.find(gsa => gsa.email == currentUserEmail);
            if(matchingAccount){
              this.googleCalendarOwner = matchingAccount.email;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveSchedule() {
      if(!this.$refs.form.validate()){
        this.addMessage('Please check your input');
        return;
      }

      let data = null;
      if(this.scheduleMode == 'recurring'){
        data = this.saveRecurringSchedule();
      }
      else{
        data = this.saveOneTimeSchedule();
      }

      if(data == null){
        return;
      }

      this.$emit('input', data);
      this.$emit('clickNext', this.$event);
    },
    saveRecurringSchedule(){
      if(this.selectedWeekdays == null || this.selectedWeekdays.length < 1){
        this.addErrorMessage("Please choose days of week");
        return;
      }

      //Generate rrule string
      const rrule = rruleUtil.generateRRule(this.startDate, this.startTime, this.endDate, this.endTime, this.selectedWeekdays);
      
      //Set start date to first date of the rrule list
      // const firstDates = rrule.all(function (date, i){return i < 1});
      // this.startDate = moment(firstDates[0]).format("YYYY-MM-DD");
      this.startDate = this.availableDates[0].value;

      const rruleSetWithExDates = rruleUtil.rruleSetWithExDates(rrule, this.excludeDates);
      const rruleSet = rruleSetWithExDates.rruleSet;
      const exclusionObjs = rruleSetWithExDates.exclusionObjs;

      // rruleSet.rrule(rrule);

      // console.log(rrule);
      // let exclusionObjs = [];
      // if(this.excludeDates && this.excludeDates.length > 0){
      //   this.excludeDates.forEach(date => {
      //     const excludeDateTime = moment(`${date} ${this.startTime}`, 'YYYY-MM-DD HH:mm');
      //     rruleSet.exdate(excludeDateTime.toDate())
      //   });

      //   exclusionObjs = this.excludeDates.map(ex => { return {date: ex} });
      // }

      const rruleSetString = rruleSet.toString();
      const rruleString = rrule.toString();
// console.log(rruleString);

      const inclusiveObjs = this.availableDates.map(d => { return { date: d.value }});
      const timezoneOffset = new Date().getTimezoneOffset()

      // const selectedGoogleAccount = this.gSuiteAccounts.find(g => g.email == this.googleCalendarOwner)

      const data = {
        id: this.id,
        recurring: true,
        startDate: this.startDate,
        endDate: this.endDate,
        daysOfWeek: this.selectedWeekdays,
        rrule: rruleString,
        rruleWithExdate: rruleSetString,
        remark: this.remark,
        startTime: this.startTime,
        endTime: this.endTime,
        exclusionDates: exclusionObjs,
        availableDates: inclusiveObjs,
        syncGoogleCalendarEvent: this.syncGoogleCalendarEvent,
        // googleAccount: selectedGoogleAccount,
        // reminders: this.selectedReminders,
        timezoneOffset: timezoneOffset,
      };

      return data;
    },
    saveOneTimeSchedule(){

      const timezoneOffset = new Date().getTimezoneOffset()
      // const selectedGoogleAccount = this.gSuiteAccounts.find(g => g.email == this.googleCalendarOwner)
      const utcDate = this.convertDateTime2Utc(this.startDate);

      const data = {
        id: this.id,
        recurring: false,
        startDate: utcDate.format('YYYY-MM-DD'),
        daysOfWeek: [utcDate.isoWeekday()-1], // set Monday to 0 instead of 1
        remark: this.remark,
        startTime: this.startTime,
        endTime: this.endTime,
        syncGoogleCalendarEvent: this.syncGoogleCalendarEvent,
        timezoneOffset: timezoneOffset,
      };

      return data;
    },
    calculateDates() {
      if (this.startDate) {
        const rrule = rruleUtil.generateRRule(this.startDate, this.startTime, this.endDate, this.endTime, this.selectedWeekdays);
      // console.log(rrule.toString())
        const allIncludedDates = rrule.all(function (date, i){return i < 100});
  // console.log(allIncludedDates)
        this.availableDates = allIncludedDates.map( d => {
          const localDate = DateTime.fromJSDate(d)
                              .toUTC()
                              .setZone('local', { keepLocalTime: true })
                              .toJSDate();
          return {
                value: moment(localDate).format("YYYY-MM-DD"),
                label: moment(localDate).format("ddd MMM DD, YYYY"),
              }
        })
        // console.log(this.availableDates)

        //remove all exclusion dates that are not in available
        if(this.excludeDates && this.excludeDates.length > 0){
          this.excludeDates = this.excludeDates.filter(d => this.availableDates.find(ad => ad.value == d) );
        }
      } else {
        this.availableDates = [];
        this.exclusionDates = [];
      }
    },
    convertDateTime2Utc(date, time){
      time = time ? time:'00:00';
      return moment.utc(`${date} ${time}`, 'YYYY-MM-DD HH:mm');
    }
  },
};
</script>

<style>
</style>